import type { Flight, FlightLeg } from '../types';

export function roundTripLegReferences(outbound: Flight, returnFlight?: Flight | null) {
  const outboundRef = Math.max(0, outbound.price);
  const returnRef =
    returnFlight?.price != null && returnFlight.price > 0 ? returnFlight.price : 0;
  return {
    outboundRef,
    returnRef,
    total: outboundRef + returnRef,
  };
}

/** Quoted reference per person: outbound list fare + return option fare. */
export function roundTripReferencePerPerson(outbound: Flight, returnFlight?: Flight | null): number {
  const { total } = roundTripLegReferences(outbound, returnFlight);
  return total;
}

export function routeSummaryLabel(f: Pick<Flight, 'departure' | 'arrival' | 'returnLeg'>): string {
  if (f.returnLeg) {
    return `${f.departure} → ${f.arrival} · return ${f.returnLeg.departure} → ${f.returnLeg.arrival}`;
  }
  return `${f.departure} → ${f.arrival}`;
}

export function flightSummaryLabel(f: Flight): string {
  if (f.returnLeg) {
    return `Round trip · ${f.airline} ${f.flightNumber}`;
  }
  return `${f.airline} ${f.flightNumber}`;
}

export function legToStoredReturnLeg(returnFlight: Flight, returnDate: string): FlightLeg {
  return {
    ...copyLegFields(returnFlight),
    travelDate: returnFlight.travelDate ?? returnDate,
    referencePrice: returnFlight.price,
  };
}

function copyLegFields(f: Flight | FlightLeg): FlightLeg {
  return {
    airline: f.airline,
    flightNumber: f.flightNumber,
    departure: f.departure,
    arrival: f.arrival,
    departureTime: f.departureTime,
    arrivalTime: f.arrivalTime,
    travelDate: f.travelDate,
    totalDuration: f.totalDuration,
    stopsCount: f.stopsCount,
    layovers: f.layovers,
    segments: f.segments,
    referencePrice: 'referencePrice' in f ? f.referencePrice : undefined,
  };
}

export function mergeRoundTripFlight(outbound: Flight, returnFlight: Flight, returnDate: string): Flight {
  const { outboundRef, total } = roundTripLegReferences(outbound, returnFlight);
  return {
    ...outbound,
    price: total,
    outboundReferencePrice: outboundRef,
    tripType: '1',
    returnDate: returnDate.trim(),
    returnLeg: legToStoredReturnLeg(returnFlight, returnDate.trim()),
  };
}
